import "../../index83.css";
import { jsx as n } from "react/jsx-runtime";
import { useCallback as c } from "react";
import { CloseLineIcon as f, QuestionLineIcon as C, InformationLineIcon as h, ErrorWarningLineIcon as w, CheckboxCircleLineIcon as I } from "@ifrc-go/icons";
import { _ as k } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import r from "../Button/index.js";
import y from "../Container/index.js";
import N from "../../hooks/useTranslation.js";
const b = "common", x = {
  alertCopyErrorDetails: "Copy error details",
  closeButtonTitle: "Close"
}, B = {
  namespace: b,
  strings: x
}, L = "_alert_uuuo4_1", T = "_icon_uuuo4_8", v = "_close-icon_uuuo4_12", D = "_info_uuuo4_16", V = "_success_uuuo4_20", A = "_danger_uuuo4_24", E = "_warning_uuuo4_28", o = {
  alert: L,
  icon: T,
  closeIcon: v,
  info: D,
  success: V,
  danger: A,
  warning: E
}, M = {
  success: o.success,
  warning: o.warning,
  danger: o.danger,
  info: o.info
}, W = {
  success: /* @__PURE__ */ n(I, { className: o.icon }),
  danger: /* @__PURE__ */ n(w, { className: o.icon }),
  info: /* @__PURE__ */ n(h, { className: o.icon }),
  warning: /* @__PURE__ */ n(C, { className: o.icon })
};
function G(l) {
  const {
    name: t,
    className: u,
    type: i = "info",
    title: m,
    description: d,
    onCloseButtonClick: s,
    nonDismissable: g,
    debugMessage: e
  } = l, a = N(B), _ = c(
    () => {
      s && s(t);
    },
    [s, t]
  ), p = c(
    () => {
      e && navigator.clipboard.writeText(e);
    },
    [e]
  );
  return /* @__PURE__ */ n(
    y,
    {
      className: k(
        o.alert,
        M[i],
        u
      ),
      headerIcons: W[i],
      heading: m,
      headingLevel: 5,
      headerActions: g && /* @__PURE__ */ n(
        r,
        {
          name: void 0,
          onClick: _,
          colorVariant: "text-on-dark",
          styleVariant: "action",
          title: a.closeButtonTitle,
          children: /* @__PURE__ */ n(f, { className: o.closeIcon })
        }
      ),
      withoutWrapInHeader: !0,
      footerActions: e && /* @__PURE__ */ n("div", { className: o.actions, children: /* @__PURE__ */ n(
        r,
        {
          name: void 0,
          onClick: p,
          colorVariant: "text-on-dark",
          styleVariant: "action",
          children: a.alertCopyErrorDetails
        }
      ) }),
      withPadding: !0,
      withShadow: !0,
      children: d
    }
  );
}
export {
  G as default
};
